import { ArpMedia } from '@arpeggi/shared'

export const detailPagePath = (arpMedia: Pick<ArpMedia, 'type' | 'id'>) =>
  `/${arpMedia.type}?token=${arpMedia.id}`
